// Core
import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import {
  getSchemas, deactivateTemplates,
  getAllTemplates,
  activateTemplate,
  deactivateTemplate,
  getTemplatesByTag,
  changesMade
} from '../../actions/actions'
import { getQueryParams } from '../../utils'

const DEFAULT_TEMPLATE = 'e8379a76-e573-4f8f-a1fc-13a94851b831'

export class TemplateSelector extends Component {
  constructor () {
    super()
    this.state = {
      showModal: false,
      params: {}
    }
  }

  componentDidMount () {
    const { templates: { selected } } = this.props
    const params = getQueryParams()
    this.setState({
      params: params
    }, () => {
      const { params: { restrictTemplateSelection } } = this.state
      if (!restrictTemplateSelection) document.addEventListener('click', this.toggleMultiSelect)
      if (!selected.length && restrictTemplateSelection) this.handleSelectTemplate(null)
    })
    if (params.templateTags) {
      this.props.dispatch(getTemplatesByTag(params.templateTags))
    } else {
      this.props.dispatch(getAllTemplates())
    }
  }

  toggleTemplate = id => {
    const { dispatch, templates: { selected: selectedTemplates, maxTemplates } } = this.props
    if (selectedTemplates.indexOf(id) > -1) {
      dispatch(deactivateTemplate(id))
    } else {
      if (maxTemplates === -1 || selectedTemplates.length < maxTemplates) {
        dispatch(activateTemplate(id))
      }
    }
    dispatch(getSchemas())
    dispatch(changesMade())
  }

  handleSelectTemplate = evt => {
    const dispatch = this.props.dispatch
    const value = evt ? evt.target.value : DEFAULT_TEMPLATE
    dispatch(deactivateTemplates())
    dispatch(activateTemplate(value))
    dispatch(getSchemas())
    dispatch(changesMade())
  }

  toggleMultiSelect = evt => {
    const dropdown = document.getElementById('multiselect-drop')
    if (evt.target.getAttribute('data-option')) return
    if (dropdown.style.visibility === 'hidden' && evt.target.getAttribute('data-backer')) dropdown.style.visibility = 'visible'
    else dropdown.style.visibility = 'hidden'
  }

  handleBgPress = evt => {
    if (evt.target === evt.currentTarget) {
      this.closeTemplateSelector()
    }
  }

  handleOpenTemplateSelector = () => {
    this.listenForEsc()
    this.setState({
      showModal: true
    })
  }

  closeTemplateSelector = (backToItem = false) => {
    window.removeEventListener('keyup', this.keyedUp)
    this.setState({
      showModal: false
    })
    this.props.dispatch(getSchemas())
    if (backToItem) {
      this.props.onClearModal()
    }
  }

  listenForEsc () {
    window.removeEventListener('keyup', this.keyedUp)
    window.addEventListener('keyup', this.keyedUp)
  }

  keyedUp = evt => {
    if (evt.keyCode === 27) {
      this.closeTemplateSelector(true)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.modal === 'template' && nextProps.modal !== 'template') {
      this.closeTemplateSelector()
    }
    if (!this.props.modal && nextProps.modal === 'template') {
      this.handleOpenTemplateSelector()
    }
  }

  componentWillUnmount () {
    const { params: { restrictTemplateSelection } } = this.state
    if (!restrictTemplateSelection) document.removeEventListener('click', this.toggleMultiSelect)
    window.removeEventListener('keyup', this.keyedUp)
  }

  render () {
    const { showModal, params } = this.state
    const { app: { primaryColor } } = this.props
    const { templates, selected, showTemplateSelector } = this.props.templates
    if (!templates || !showTemplateSelector) {
      return null
    }
    let list = null
    let modal = null
    let templateField = null
    let currentSelection = null
    const selectedOptions = []
    if (showModal) {
      list = templates.map(template => {
        const { name, id, description } = template
        if (params.restrictTemplateSelection === 'true') {
          return (
            <li key={id} className={css.li}>
              <label>
                <input type='radio' checked={selected.indexOf(id) > -1} onChange={() => this.handleSelectTemplate(id)} /> {name}
              </label>
              <p style={{ display: description ? 'block' : 'none' }} className={css.desc}>
                {description}
              </p>
            </li>
          )
        }
        return (
          <li key={id} className={css.li}>
            <label>
              <input type='checkbox' checked={selected.indexOf(id) > -1} onChange={() => this.toggleTemplate(id)} /> {name}
            </label>
            <p style={{ display: description ? 'block' : 'none' }} className={css.desc}>
              {description}
            </p>
          </li>
        )
      })
      modal = (
        <article className={css.backer} onClick={this.handleBgPress}>
          <div className={`${css.frame} ${this.props.app.standAloneMode ? css.frameStandAlone : ''}`}>
            <header className={css.header}>
              <h3 className={css.h3}>
                Select Template
              </h3>
            </header>
            <div className={css.content}>
              <ul className={css.list}>
                {list}
              </ul>
            </div>
          </div>
        </article>
      )
    }
    if (templates) {
      list = templates.map(template => {
        const { name, id } = template
        if (params.restrictTemplateSelection) {
          if (selected.indexOf(id) > -1) currentSelection = id
          return <option value={id} key={id}>{name}</option>
        }
        if (selected.indexOf(id) > -1) {
          if (selectedOptions.length) selectedOptions.push(`, ${name}`)
          else selectedOptions.push(name)
        }
        return (
          <div className={css.option} key={id} data-option>
            <label data-option>
              <input type='checkbox' className={css.check} checked={selected.indexOf(id) > -1} onChange={() => this.toggleTemplate(id)} data-option /> {name}
            </label>
          </div>
        )
      })
    }
    if (params.restrictTemplateSelection) {
      templateField = (
        <select className={css.select} onChange={this.handleSelectTemplate} value={currentSelection || DEFAULT_TEMPLATE}>
          {list}
        </select>
      )
    } else {
      templateField = (
        <div data-backer>
          <span>{selectedOptions.length ? selectedOptions : 'No Templates Selected'}</span>
          <div className={css.dropdown} id='multiselect-drop' style={{ visibility: 'hidden' }}>
            {list}
          </div>
        </div>
      )
    }
    return (
      <div className={css.templateSelect}>
        <label className={css.label}>Template</label>
        <div className={css.backer} data-backer>
          {templateField}
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  const { app, auth, item, templates } = state
  return {
    app,
    auth,
    item,
    templates
  }
}

export default connect(mapStateToProps)(TemplateSelector)



// WEBPACK FOOTER //
// /app/js/components/TemplateSelector/index.js